import { createMetricsFactory } from 'metrics-js';
const Metrics = createMetricsFactory('automation-ui-log-events');
export default Metrics;